export enum TabsEnum {
  KAPLAN_PRICELISTS,
  ALPADIA_PRICELISTS,
  AYA_PRICELISTS,
  JUNIOR_CAMPS_PRICELISTS,
  ONLINE_COURSES,
  PUBLIC_HOLIDAYS,
  KAPLAN_TERMS_AND_CONDITIONS,
  ALPADIA_TERMS_AND_CONDITIONS,
}
